import { Component } from '@angular/core';

interface Feature {
  title: string;
  description: string;
  icon: string;
}

@Component({
  selector: 'app-features-section',
  templateUrl: './features-section.component.html',
  styleUrl: './features-section.component.scss',
  standalone: false
})
export class FeaturesSectionComponent {

  features: Feature[] = [
    {
      title: 'Integración Web',
      description: 'Implementación sencilla en cualquier sitio web mediante un simple widget personalizable.',
      icon: 'bi bi-globe'
    },
    {
      title: 'Conexión WhatsApp',
      description: 'Comunicación directa con tus clientes a través de la plataforma de mensajería más popular del mundo.',
      icon: 'bi bi-whatsapp'
    },
    {
      title: 'IA Generativa Avanzada',
      description: 'Respuestas naturales y precisas gracias a los modelos de lenguaje más avanzados.',
      icon: 'bi bi-cpu'
    },
    {
      title: 'Personalización Total',
      description: 'Adapta el aspecto y comportamiento del asistente para que refleje perfectamente tu marca.',
      icon: 'bi bi-sliders'
    },
    {
      title: 'Análisis de Conversaciones',
      description: 'Obtén insights valiosos y mejora continuamente con nuestro panel de análisis avanzado.',
      icon: 'bi bi-graph-up'
    },
    {
      title: 'Integración con CRM',
      description: 'Conecta con tus sistemas existentes para una gestión unificada de la relación con el cliente.',
      icon: 'bi bi-diagram-3'
    }
  ];

}
